import { Flex } from '@opendoor/bricks/core';
import { GenericError, IGenericErrorProps } from '@opendoor/cinderblocks/platform/GenericError';

import layoutWrapper from '../hocs/layoutWrapper';

const ErrorPage: React.FC<IGenericErrorProps> = (props) => {
  return (
    <Flex justifyContent="center">
      <GenericError {...props} />
    </Flex>
  );
};

export default layoutWrapper(ErrorPage, {
  headerType: 'FULL',
  footerType: 'MINIMAL',
});
